<mat-card>
  <mat-card-header>
    <mat-card-title>
      <mat-icon class="icon-20">admin_panel_settings</mat-icon> Admin Functions
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <section *ngIf="!isAdmin">
      <p>You do not have permission to use the admin functions.</p>
    </section>

    <section *ngIf="isAdmin">
      <mat-card class="function-card">
        <mat-card-header>
          <mat-card-title>Migrate Database Documents to Blob Storage</mat-card-title>
          <mat-card-subtitle>
            Moves every document currently stored in the database into Azure Blob Storage and records it
            in the unified Document table.
          </mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
          <p *ngIf="status">
            <strong>Documents still to copy:</strong> {{ status.pendingCopyCount }}
          </p>

          <div class="migration-actions">
            <button mat-raised-button color="primary" [disabled]="!canStart('Copy')" (click)="start('Copy')">
              1. Copy to blob storage
            </button>
            <button mat-raised-button color="primary" [disabled]="!canStart('Verify')" (click)="start('Verify')">
              2. Verify
            </button>
            <button mat-raised-button color="warn" [disabled]="!canStart('Reclaim')" (click)="start('Reclaim')">
              3. Reclaim database space
            </button>
            <button mat-stroked-button [disabled]="!isRunning" (click)="cancel()">Cancel</button>
            <button mat-icon-button title="Refresh" aria-label="Refresh" (click)="refresh()">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>

          <section *ngIf="job" class="migration-status">
            <p>
              <strong>Latest run:</strong> {{ job.phase }} &mdash; {{ job.status }}
              <span *ngIf="job.startedBy"> (started by {{ job.startedBy }})</span>
            </p>

            <mat-progress-bar
              *ngIf="isRunning"
              mode="determinate"
              [value]="progressPercent"
              aria-label="Migration progress">
            </mat-progress-bar>

            <p>
              Processed {{ job.processedCount }} of {{ job.totalCount }}
              &mdash; {{ job.succeededCount }} succeeded, {{ job.failedCount }} failed
              <span *ngIf="isRunning && job.currentSourceTable"> &mdash; currently {{ job.currentSourceTable }}</span>
            </p>

            <p *ngIf="job.errorMessage" class="migration-error">{{ job.errorMessage }}</p>

            <button
              mat-stroked-button
              *ngIf="job.failedCount > 0"
              (click)="downloadFailureReport()">
              Download failure report
            </button>
          </section>

          <section *ngIf="history?.length">
            <h4>Recent runs</h4>
            <table class="mat-elevation-z1 history-table">
              <tr>
                <th>Phase</th>
                <th>Status</th>
                <th>Processed</th>
                <th>Failed</th>
                <th>Started</th>
                <th>Completed</th>
              </tr>
              <tr *ngFor="let run of history">
                <td>{{ run.phase }}</td>
                <td>{{ run.status }}</td>
                <td>{{ run.processedCount }} / {{ run.totalCount }}</td>
                <td>{{ run.failedCount }}</td>
                <td>{{ run.startedUtc | date: 'short' }}</td>
                <td>{{ run.completedUtc | date: 'short' }}</td>
              </tr>
            </table>
          </section>
        </mat-card-content>
      </mat-card>
    </section>
  </mat-card-content>
</mat-card>
